// extracted by mini-css-extract-plugin
module.exports = {"container":"InfiniteScrollSpinner_container__zR_QJ","spinner":"InfiniteScrollSpinner_spinner__Reg8v"};